import { detect } from 'detect-browser'
import { createLogger } from './log'

const browser = detect()
const isMac = browser.os === 'Mac OS'
const log = createLogger('KEYBOARD')

export const modifierKeys = {
	META: 'metaKey',
	CTRL: 'ctrlKey',
	SHIFT: 'shiftKey',
	ALT: 'altKey',
}
const keyboardAliasMapper = {
	command: isMac ? modifierKeys.META : modifierKeys.CTRL,
	cmd: isMac ? modifierKeys.META : modifierKeys.CTRL,
	opt: modifierKeys.ALT,
	win: modifierKeys.META,
	shift: modifierKeys.SHIFT,
	shft: modifierKeys.SHIFT,
	ctl: modifierKeys.CTRL,
	ctrl: modifierKeys.CTRL,
	esc: 'Escape',
	tab: 'Tab',
}

const modifierKeyValues = Object.values(modifierKeys)

const eventContainsKey = (e, key) => {
	key = keyboardAliasMapper[key.toLowerCase()] || key
	if (modifierKeyValues.includes(key)) return !!e[key] // modifier keys are boolean values on the event
	return e.key.toLowerCase() === key.toLowerCase() // ignore casing for more reliable test
}

export const listenForKeyboardShortcut = (keys = [], callback) => {
	keys = typeof keys === 'string' ? keys.split('+') : keys
	function onKeydownForShortcut(e) {
		// Check if all required keys are present
		const allKeysPresent = keys.every((key) => eventContainsKey(e, key))
		// Map the keys to their actual values for comparison
		const mappedKeys = keys.map(
			(key) => keyboardAliasMapper[key.toLowerCase()] || key
		)
		// Check if no extra keys are pressed (CMD + CTRL + F should not trigger CMD + )
		const noExtraKeys = modifierKeyValues.every(
			(modKey) => !e[modKey] || mappedKeys.includes(modKey)
		)
		if (!allKeysPresent || !noExtraKeys) return
		// this keystroke matches all of the required modifiers
		log('shortcut:', keys)
		e.preventDefault()
		callback(e)
	}
	document.addEventListener('keydown', onKeydownForShortcut)
	return () => {
		// calling this returned function will remove the listener
		document.removeEventListener('keydown', onKeydownForShortcut)
	}
}
